import { browsingDomainStore } from '../../store';
export const getFetchedSiteById = (id) => {
    return browsingDomainStore.data.sitesById[id];
};
//# sourceMappingURL=get-fetched-site-by-id.js.map